import React, { useEffect, useState } from 'react';
import Table from '../common/Table';
import tableConfig, { data } from './config';
import API from '../../utils/api';
import moment from 'moment';

const VerifyPaymentsList = (props) => {
  const classes = props.classes;

  const verifyPayment = (order_id) => {
    checkPaymentVerification(order_id)
  }

  let config = tableConfig(props, verifyPayment);
  const [recentPayments, setRecentPayments] = useState({
    data: [],
    total: 0
  });

  useEffect(() => {
    // fetchPayments();
  }, []);

  const fetchPayments = async () => {
    try {
      let limit = 10;
      let skip = recentPayments?.data?.length;

      // setIsLoading(true)
      let query = `limit=${limit}&skip=${skip}`
      // if (invoice_id) {
      //   query += `&invoice_id=${invoice_id}`
      // }

      // const paymentsDataRes = await API.get(`/admin/recent-payments?${query}`);
      const paymentsDataRes = await API.get(`/admin/recent-payments?${query}`);
      let responseData = (paymentsDataRes.data && paymentsDataRes.data.ResponseData) || []
      let paymentsData = ((responseData && responseData.data) || [])

      if (paymentsData.length > 0) {
        let resFormate = [];
        for (let item of paymentsData) {
          resFormate.push({
            "invoice_id": item.order.invoice_id,
            "amount": item.amount,
            "order_local_date": moment(item.date_system).local().format('YYYY-MM-DD hh:mm A'),
            "payment_status": item.payment_status,
          })
        }
        setRecentPayments({
          data: [...recentPayments?.data, ...resFormate],
          total: responseData.total || 0,
        })
      }

      // setTableKey(tableKey + 1)
    } catch (error) {
      console.log(error);
    }
  };


  const checkPaymentVerification = async (order_id) => {
    try {
      console.log({order_id});
      const checkPayment = await API.put(`/admin/verify-payment/${order_id}`);

      // setTableKey(tableKey + 1)
    } catch (error) {
      console.log(error);
    }
  };

  return (<Table
    tableConfig={config}
    data={recentPayments?.data}
    pageSizeValue={10}
    url={'/admin/recent-payments'}
    pageSize={5}
    apidata={"receptPayment"}
  />)
};

export default VerifyPaymentsList;
